function clamp(val, min, max) {
  return Math.min(Math.max(val, min), max);
}

module.exports = clamp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/pure-color/util/clamp.js
// module id = 99
// module chunks = 0 1